export default {"src":"/_next/static/media/error-stage.ca3fb56b.svg","height":150,"width":150};